import { Box, SvgIcon } from "@mui/material";
 // assets
 import { ReactComponent as Logo } from "../../assets/images/logo/city-logo.svg";

const LogoBottom: React.FC = (): React.ReactElement => {
  return (
    <Box
      sx={{
        display: "flex",
        flex: 1,
        alignItems: "flex-end",
        justifyContent: "flex-start",
      }}
    >
      <SvgIcon
        component={Logo}
        viewBox="0 0 71 71"
        sx={{ width: "4.375rem", height: "4.375rem", margin: "20px" }}
      />
    </Box>
  )
};

export default LogoBottom;